module.exports = __webpack_public_path__ + "9779d9a1/img/saly-icon.39e12342.jpg";